import { Component, ViewChild } from '@angular/core';
import { Platform, NavController, NavParams, AlertController, ActionSheetController, App } from 'ionic-angular';
import { AppVersion } from '@ionic-native/app-version'

import { PreloginPage } from '../prelogin/prelogin';
import { ConsumerRewardListPage } from '../consumer-reward-list/consumer-reward-list';
import { ConsumerOfferUserListPage } from '../consumer-offer-user-list/consumer-offer-user-list';
import { ConsumerPinsPage } from '../consumer-pins/consumer-pins';
import { PaymentMethodListPage } from '../../pages/payment-method-list/payment-method-list';

import { ConsumerHandlerProvider } from '../../providers/consumer-handler';
import { Globals } from '../../providers/globals';

import { Storage } from '@ionic/storage';
import { Camera, CameraOptions } from '@ionic-native/camera';

declare var bumerang: any;
declare var FB: any;

@Component({
  selector: 'page-consumer-profile',
  templateUrl: 'consumer-profile.html',
})
export class ConsumerProfilePage {	
	@ViewChild('fileInput') fileInput;

	filePath: any;
	profile: any = {
		ImagePath: "",
		FullName: "",
		AvailablePoints: "",
	};
	imageChanging: boolean = false;
	isLoading: boolean = false;
	appVersionPrint: any = "1.0";

	constructor(
		platform: Platform, 
		public appVersion: AppVersion,
		public consumerHandlerProvider: ConsumerHandlerProvider,
		public navController: NavController,
		public globals: Globals,
		public alertCtrl: AlertController,
		public storage: Storage,
		public app: App,
		private camera: Camera,
		public actionSheetCtrl: ActionSheetController,
		public navCtrl: NavController
		) {
		this.filePath = "assets/images/profile.png";

		platform.ready().then((readySource) => {
	        if(readySource!="dom"){
				this.appVersion.getVersionNumber().then((version)=> {
		    		this.appVersionPrint = version;
				});	          
	        }
		});
	}

	ionViewDidLoad() {
		this.load(null);
	}	

	load(cb){
		this.isLoading = true;

		this.consumerHandlerProvider.getProfile((profile)=>{
			this.profile = profile;

			var joinDate = new Date(this.profile.JoinDate);

			this.profile.JoinDateFormatted = joinDate.toLocaleDateString();

			if(profile.ImagePath){
				this.filePath = this.globals.fileUrl + profile.ImagePath;	
			}			

			this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		})
	}	

	chooseSource() {
		if (Camera['installed']()) {
		   let actionSheet = this.actionSheetCtrl.create({
		     title: 'Choose the source for an image',
		     buttons: [
		       {
		         text: 'Camera',
		         handler: () => {

		           this.changeProfilePic(true)
		         }
		       },
		       {
		         text: 'Image Gallery',
		         handler: () => {

		           this.changeProfilePic(false)
		         }
		       },
		       {
		         text: 'Cancel',
		         role: 'cancel',
		         handler: () => {
		           console.log('Cancel clicked');
		         }
		       }
		     ]
		   });

		   actionSheet.present();

		}else{
			this.fileInput.nativeElement.click();
		}
	}

	processWebImage(event) {
		let reader = new FileReader();

		reader.onload = (readerEvent) => {
			let imageData = (readerEvent.target as any).result;

			this.imageChanging = true;

			this.consumerHandlerProvider
			.updateProfileImage({
			imageString: imageData,
				cb: (data)=>{
					this.imageChanging = false;

					console.log("New image path: " + data);

					this.profile.ImagePath = data;

					this.filePath = this.globals.fileUrl + this.profile.ImagePath;	
				}
			});
		};

		reader.readAsDataURL(event.target.files[0]);
	}	

	changeProfilePic(fromCamera){

		var sourceType = fromCamera ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY

	  	let cameraOptions = {
		    sourceType: sourceType,
		    destinationType: this.camera.DestinationType.DATA_URL,  
		    mediaType: this.camera.MediaType.PICTURE,    
		    allowEdit: true,
		    quality: 30,
		    targetWidth: 500,
		    targetHeight: 500,		    
		    encodingType: this.camera.EncodingType.PNG,      
		    correctOrientation: true
	 	}

	  	this.camera
	  	.getPicture(cameraOptions)
	    .then(dataUrl => {
	    	this.imageChanging = true;

    		this.consumerHandlerProvider
    		.updateProfileImage({
    			imageString: 'data:image/png;base64,' + dataUrl,
    			cb: (data)=>{
    				this.imageChanging = false;

    				console.log("New image path: " + data);

    				this.profile.ImagePath = data;

    				this.filePath = this.globals.fileUrl + this.profile.ImagePath;	
    			}
    		})
	    }, err => {
	    	console.log("New error: ");

	    	console.log(err);
	    });
	}


	logOut(){
		let confirm = this.alertCtrl.create({
		  title: 'Logout?',
		  message: 'Are you sure you want to log out?',
		  buttons: [
		    {
		      text: 'No',
		      handler: () => {
		        console.log('Disagree clicked');
		      }
		    },
		    {
		      text: 'Yes',
		      handler: () => {
		      	this.globals.loginData={
			 		access_token: ""
			 	};

		        this.storage.set('loginData', this.globals.loginData)
	
				if(bumerang){
			        if(bumerang.fbData.authResponse){
			        	if(bumerang.fbData.status=="connected"){
							FB.logout(function(response) {
							   var i = response;
							   this.app.getRootNav().setRoot(PreloginPage);		        	
							});		        		
			        	}
			        }else{
			        	this.app.getRootNav().setRoot(PreloginPage);		        	
			        }						
				}else{
					this.app.getRootNav().setRoot(PreloginPage);		        	
				}	        

		        if(bumerang && bumerang.fbData.authResponse){
		        	if(bumerang.fbData.status=="connected"){
						FB.logout(function(response) {
						   var i = response;
						   this.app.getRootNav().setRoot(PreloginPage);		        	
						});		        		
		        	}
		        }else{
		        	this.app.getRootNav().setRoot(PreloginPage);		        	
		        }		        		       
		      }  
		    }
		  ]
		});

		confirm.present();
	}	

	openPage(pageName){
	  switch (pageName) {
	    case "methods":
	      this.navCtrl.push(PaymentMethodListPage, {});
	      break;                
	 	}
	}

}




// WEBPACK FOOTER //
// ./src/pages/consumer-profile/consumer-profile.ts